var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"\n    relative\n    z-50\n    grid grid-cols-2\n    w-double\n    lg:w-screen\n    h-full\n    transition\n    duration-500\n    transform\n    bg-white bg-opacity-90\n    overflow-hidden\n  ",class:{
    'opacity-0 pointer-events-none': _vm.hidden,
    'opacity-100 pointer-events-auto': !_vm.hidden,
    '-translate-x-1/2 lg:translate-x-0 pb-10 lg:pb-0': !_vm.menu,
    'pb-0': _vm.menu,
  }},[_c('navigation',{attrs:{"view":_vm.view},on:{"open":_vm.updateHistory}}),_c('viewer',{ref:"view",attrs:{"view":_vm.view}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }